// src/store/index.js
import api from '@/api';
import axios from 'axios';
import { createStore } from 'vuex';
const baseURL = process.env.VUE_APP_API_BASE_URL;
function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
}
export default createStore({
  state: {
    isAuthenticated: localStorage.getItem('isAuthenticated') ? JSON.parse(localStorage.getItem('isAuthenticated')) : false,
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
    token: localStorage.getItem('token') || null,
    //token: localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : null,
  },
  mutations: {
    // Mutation pour définir l'état d'authentification
    setAuthenticated(state) {
      state.isAuthenticated = true;
      localStorage.setItem('isAuthenticated',JSON.stringify(state.isAuthenticated)) //sauvegarde dans le storage
      
    },
    setUser(state, user) {
      state.user = user;
      localStorage.setItem('user',JSON.stringify(user));    
    },
    setToken(state,token) {
      state.token = token;
      localStorage.setItem('token', token)
    },
    
    logout(state) {
    state.isAuthenticated = false;
    state.user = null;
    state.token = null;
    localStorage.clear();

    }

  },
  actions: {
    // Action pour mettre à jour l'état d'authentification, peut-être après une connexion réussie
 async authenticate({ commit }, credentials) {
  try {
    const loginResponse = await axios.post(`${baseURL}/api/login`, {
      identifiant: credentials.email,
      password: credentials.password
    });

    const token = loginResponse.data.token;
    if (!token) return { success: false, disabled: false };

    commit('setToken', token);

    const decoded = parseJwt(token);
    if (!decoded) return { success: false, disabled: false };

    console.log(decoded);

    if (decoded.enabled === false) {
      return { success: false, disabled: true };
    }

    commit('setUser', decoded);
    commit('setAuthenticated');

    return { success: true, disabled: false };

  } catch (error) {
    console.error('Erreur d\'authentification:', error.response?.data || error.message);
    return { success: false, disabled: false };
  }
}
  
,

    logout({commit}) {
      commit('logout');
    },
      async refreshUser({ commit, state }) {
    if (!state.user?.id) return;

    try {
      const response = await api.getItem("type_users", state.user.id);
      const freshUser = response.data;

      commit("setUser", freshUser); // met à jour Vuex + localStorage
    } catch (error) {
      console.error("Erreur lors de l'actualisation du user:", error);
    }
  }

  },
  getters: {
  isAuthenticated: (state) => state.isAuthenticated,
  user: (state) => state.user,

  // Vérifie si l'utilisateur est Super Admin
 isSuperAdmin: (state) => {
  const roles = state.user?.roles || [];
  return roles.some(role => role.toUpperCase() === "ROLE_SUPER_ADMIN");
},

  // Vérifie si l'utilisateur a une permission donnée
hasPermission: (state, getters) => (permission) => {
  if (getters.isSuperAdmin) return true; // Super Admin = tous les droits

  // Permissions récupérées directement sur le user
  const permissions = state.user?.permissions || [];

  return permissions.map((p) => p.toLowerCase()).includes(permission.toLowerCase());
},

  // Vérifie si l'utilisateur a au moins une des permissions
  hasAnyPermission: (state, getters) => (permissions = []) => {
  if (getters.isSuperAdmin) return true;

  const userPermissions = state.user?.permissions || [];
  const normalized = userPermissions.map((p) => p.toLowerCase());

  return permissions.some((perm) => normalized.includes(perm.toLowerCase()));
 },

  // Vérifie si l'utilisateur a un rôle donné
  hasRole: (state) => (role) => {
    if (!state.user || !state.user.roles) return false;
    const normalizedRole = role.toUpperCase().replace(/^ROLE_/, "");
    return state.user.roles.some(
      (r) => r.toUpperCase().replace(/^ROLE_/, "") === normalizedRole
    );
  },
}

 

});
